import {
  IMPRESSION_DEVICE_CONNECTED_TV,
  IMPRESSION_DEVICE_DESKTOP,
  IMPRESSION_DEVICE_MOBILE,
  IMPRESSION_DEVICE_TABLET,
  isGoogleImpressionDeviceSource,
} from "@nexus/contracts";

const IMPRESSION_DEVICE_LABELS: Record<string, { suffix: string; fallback: string }> = {
  [IMPRESSION_DEVICE_MOBILE]: { suffix: "mobile", fallback: "Mobile" },
  [IMPRESSION_DEVICE_CONNECTED_TV]: { suffix: "connectedTv", fallback: "Connected TV" },
  [IMPRESSION_DEVICE_DESKTOP]: { suffix: "desktop", fallback: "Desktop" },
  [IMPRESSION_DEVICE_TABLET]: { suffix: "tablet", fallback: "Tablet" },
};

/** Translates a My Brand impression-device token; unknown values pass through. */
export function impressionDeviceLabel(
  t: (key: string, defaultValue: string) => string,
  namespace: "overview" | "drilldown",
  value: string,
): string {
  const entry = IMPRESSION_DEVICE_LABELS[value];
  if (!entry) return value;
  return t(`${namespace}.filters.${entry.suffix}`, entry.fallback);
}

/**
 * Device data exists on Demand Gen, Pmax, Video, and Display rows.
 * A specific selection counts when one of those is chosen. `null` is All, which
 * counts only when the tenant's available platforms include one.
 */
export function selectionIncludesGoogle(
  selectedPlatforms: readonly string[] | null,
  availablePlatforms: readonly string[] = [],
): boolean {
  const effective = selectedPlatforms === null ? availablePlatforms : selectedPlatforms;
  return effective.some((platform) => isGoogleImpressionDeviceSource(platform));
}
